/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Submit_FailedInputs */

const en_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to submit embed job: ${i?.error}`)
};

const fr_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la soumission de la tache d'incrustation : ${i?.error}`)
};

const de_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Absenden des Einbettungsauftrags: ${i?.error}`)
};

const it_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile inviare il lavoro di incorporamento: ${i?.error}`)
};

const ru_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось отправить задание на встраивание: ${i?.error}`)
};

const es_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo enviar el trabajo de inserción: ${i?.error}`)
};

const zh_cn2_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交嵌入作业失败：${i?.error}`)
};

const ja_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`埋め込みジョブの送信に失敗しました: ${i?.error}`)
};

const hi_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`एम्बेड जॉब सबमिट करने में विफल: ${i?.error}`)
};

const pt_pt2_embed_captions_submit_failed = /** @type {(inputs: Embed_Captions_Submit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao enviar tarefa de incorporação: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to submit embed job: {error}" |
*
* @param {Embed_Captions_Submit_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submit_failed = /** @type {((inputs: Embed_Captions_Submit_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submit_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submit_failed(inputs)
	if (locale === "de") return de_embed_captions_submit_failed(inputs)
	if (locale === "it") return it_embed_captions_submit_failed(inputs)
	if (locale === "ru") return ru_embed_captions_submit_failed(inputs)
	if (locale === "es") return es_embed_captions_submit_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submit_failed(inputs)
	if (locale === "ja") return ja_embed_captions_submit_failed(inputs)
	if (locale === "hi") return hi_embed_captions_submit_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submit_failed(inputs)
	return en_embed_captions_submit_failed(inputs)
});